import { Site } from '@envato/foundation-types'
import { connect } from 'react-redux'
import { IRootState } from '../../../../common/reducers'
import { IEnhancedLocation } from '../../../../common/reducers/reactRouterLocation'

import LockupAddToCartButton from './lockupAddToCartButton'

interface IStateProps {
  currentSite: Site
  location: IEnhancedLocation
  experiments: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common, router, experiments } = state
  const { currentSite } = common
  const { location } = router

  return {
    location,
    experiments,
    currentSite
  }
}

const LockupAddToCartButtonContainer = connect<IStateProps, IRootState, any>(
  mapStateToProps
)(LockupAddToCartButton)

export default LockupAddToCartButtonContainer
